// extracted by mini-css-extract-plugin
export default {"container":"SailingInfo_container__y5yxG","columns":"SailingInfo_columns__Zj2nO"};